import { render, staticRenderFns } from "./tableauBudget.vue?vue&type=template&id=0fbb5304"
import script from "./tableauBudget.vue?vue&type=script&lang=js"
export * from "./tableauBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports